// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"b20c976b","493":"0a2d15d4","981":"5cc00e12"}[chunkId] + ".css";
};